import { FormulationAttributesOption } from './types';

export const productFormOptions: FormulationAttributesOption[] = [
  {
    name: 'topics:formulation-attributes:options:availableProductForm:powder',
    value: 'powder',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableProductForm:liquid',
    value: 'liquid',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableProductForm:granules',
    value: 'granules',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableProductForm:flakes',
    value: 'flakes',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableProductForm:paste',
    value: 'paste',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableProductForm:wax',
    value: 'wax',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableProductForm:prills',
    value: 'prills',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableProductForm:needles',
    value: 'needles',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableProductForm:piece',
    value: 'piece',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
  {
    name: 'topics:formulation-attributes:options:availableProductForm:emulsion',
    value: 'emulsion',
    applications: {
      '*|HomeCareIndustrialCleaning': [],
    },
  },
];
